import { useEffect, useState } from 'react'
import { getStoredReferral, referralSettled } from 'src/utils/referral'

/**
 * The stored affiliate referral (code, display name, offer). A ?ref= on the current page may still be validating
 * when this mounts, so it re-reads once that lookup settles: its display name and offer arrive then, and an
 * unknown code is dropped.
 */
export const useStoredReferral = () => {
    const [referral, setReferral] = useState(getStoredReferral)

    useEffect(() => {
        let cancelled = false
        referralSettled().then(() => !cancelled && setReferral(getStoredReferral()))
        return () => {
            cancelled = true
        }
    }, [])

    return referral
}
